import { render, staticRenderFns } from "./ApiMenu.vue?vue&type=template&id=c68f6fe8"
import script from "./ApiMenu.vue?vue&type=script&lang=js"
export * from "./ApiMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports